import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFolderCreationPermission = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.93598 19.989H5.16596C4.06107 19.989 3.00145 19.5443 2.22018 18.753C1.4389 17.9616 1 16.8884 1 15.7692V5.21977C1 4.10061 1.4389 3.02723 2.22018 2.23588C3.00145 1.44451 4.06107 1 5.16596 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.24414 1H7.33851C8.0695 1.00447 8.7866 1.20269 9.41857 1.575C10.0505 1.94732 10.5754 2.48078 10.9408 3.1223C11.3147 3.76572 11.8472 4.29961 12.4861 4.67166C13.1248 5.04372 13.8482 5.24118 14.585 5.24459H17.8104C18.9213 5.24459 19.9867 5.69172 20.7722 6.48774C21.5578 7.28375 21.9991 8.36345 21.9991 9.48919",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.9675,
			cy: 15.5207,
			r: 4.41479,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12.9707,
			y1: 11.8169,
			x2: 19.6727,
			y2: 18.5188,
			stroke: "currentColor"
		})
	]
});
export default SvgIconFolderCreationPermission;
